import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { TEnrichmentsSelection } from '@/features/segments/types';
import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';

type TRelaunchBroadcast = {
  id: string;
  enrichments: TEnrichmentsSelection;
};
export async function relauchBroadcast({ id, enrichments }: TRelaunchBroadcast): Promise<unknown> {
  return mediaManagerClient.patch(`/api/v1/program_broadcasts/${id}/relaunch`, enrichments);
}

type MutationFn = typeof relauchBroadcast;

type TUsePostBroadcastersParams = {
  config?: MutationConfig<MutationFn>;
};

export function usePatchRelaunchBroadcast({ config = {} }: TUsePostBroadcastersParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: relauchBroadcast,
    onError(error) {
      addErrorNotification(
        t('No se han lanzado los enriquecimientos'),
        t('Ha habido un error durante el proceso, vuelva a intentarlo más tarde')
      );
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(
        t('Se han relanzado los enriquecimientos'),
        t('El proceso ha sido un éxito')
      );
    },
  });
}
